if (!customElements.get('up-coffret')) {
  customElements.define(
    'up-coffret',

    class UpCoffret extends HTMLElement {
      constructor() {
        super();

        // Static UI
        this.productSelectors = this.querySelector('#up-coffret-selects-products');

        this.backupKey = this.dataset.backupId || '';
      }

      connectedCallback() {
        this.productSelectors.addEventListener('change', this.updateAccumulation.bind(this));

        const productThumbnailImage = document.querySelector('#product-thumbnail img');
        this.productSelectors.querySelectorAll('label').forEach((label) => {
          label.addEventListener('mouseenter', () => {
            productThumbnailImage.setAttribute('src', label.getAttribute('data-full-size-image-url'));
            productThumbnailImage.removeAttribute('srcset');
          });
        });

        this.initFromBackup();
      }

      initFromBackup() {
        this.data = JSON.parse(localStorage.getItem(this.backupKey) || '{}');

        this.productSelectors.querySelectorAll('input').forEach((input) => {
          if (!input.dataset.collectionId || !this.data.products) return;
          if (this.data.products.includes(input.dataset.collectionId) && !input.disabled) {
            input.checked = true;
          }
        });

        this.updateAccumulation();
      }

      saveData(key, value) {
        this.data[key] = value;
        localStorage.setItem(this.backupKey, JSON.stringify(this.data));
      }

      updateAccumulation() {
        const checkedInputs = Array.from(this.productSelectors.querySelectorAll('input')).filter(
          (radio) => radio.checked
        );

        // Update counter
        const counterMessage = this.productSelectors.querySelector('[data-selected-value]');
        if (counterMessage !== undefined) counterMessage.innerHTML = `${checkedInputs.length} produits sélectionnés`;

        // Update price on CTA
        // Update price for customisation price

        this.saveData(
          'products',
          checkedInputs.map((input) => input.dataset.collectionId)
        );
      }
    }
  );
}
